interface Award {
  title: string;
  organization: string;
  date: string;
}

interface Language {
  language: string;
  proficiency: string;
  description: string;
}

function AwardsAndLanguages(): JSX.Element {
  const awards: Award[] = [
    {
      title: "Professor Award",
      organization: "EGD Learning League",
      date: "April 2017"
    },
    {
      title: "Hosted two seminars on PHP libraries",
      organization: "EGD Group",
      date: ""
    }
  ];

  const languages: Language[] = [
    {
      language: "English",
      proficiency: "Highly proficient",
      description: "Highly proficient in reading technical documents with strong communication skills for collaboration with colleagues."
    },
    {
      language: "Japanese",
      proficiency: "Basic proficiency (JLPT N5)",
      description: "Basic proficiency (equivalent to JLPT N5), capable of understanding simple conversations and written text"
    }
  ];

  return (
    <div className="p-6">
      <div className="grid gap-8 md:grid-cols-2">
        <div>
          <h3 className="text-xl font-semibold text-gray-800 mb-4">Awards</h3>
          <div className="space-y-4">
            {awards.map((award: Award, index: number) => (
              <div key={index} className="border-l-4 border-yellow-500 pl-4">
                <h4 className="font-semibold text-gray-800">{award.title}</h4>
                <p className="text-gray-600">{award.organization}</p>
                {award.date && (
                  <p className="text-gray-500 text-sm">{award.date}</p>
                )}
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-gray-800 mb-4">Languages</h3>
          <div className="space-y-4">
            {languages.map((lang: Language, index: number) => (
              <div key={index} className="border-l-4 border-green-500 pl-4">
                <h4 className="font-semibold text-gray-800">{lang.language}</h4>
                <p className="text-blue-600 font-medium text-sm">{lang.proficiency}</p>
                <p className="text-gray-700 text-sm leading-relaxed">{lang.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AwardsAndLanguages;